module.exports = __webpack_public_path__ + "27b1efe526dc3aa1b6c7ea57c9f06929.svg";